import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Helmet } from 'react-helmet'

import './layout.css'

const cYear = new Date().getFullYear()

const Layout = ({ children, location }) => {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          description
          title
        }
      }
    }
  `)

  const { title } = data.site.siteMetadata

  return (
    <div
      style={{
        margin: '0 auto',
        maxWidth: '42rem',
        padding: '1.45rem 1rem',
      }}
    >
      <Helmet defaultTitle={title} titleTemplate={'%s - ' + title}>
        <meta name="copyright" content={cYear} />
        <meta name="twitter:site" content="@laramiedennis" />
        <meta name="og:type" content="website" />
        <meta name="og:site_name" content={title} />
        <html lang="en" />
      </Helmet>
      <main role="main">{children}</main>
    </div>
  )
}

export default Layout
